import { Modal, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { Box } from '@mui/system';
import { DataGrid } from '@mui/x-data-grid';
import { useApi } from 'Service/axios';
import { useEffect } from 'react';
import { useState } from 'react';
import { useDataFilterCosts } from 'store/ContextData';
import SimpleTable from 'ui-component/SimpleTableComponent';
import { formatarValorIntl } from 'utils/formatValueIntl';
import { formatarNumero } from 'utils/formatarNumeroReal';
import { formatarData } from 'utils/regex';
const TaxesModal = ({ open, setOpen, dataParams, currentMode }) => {
    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '95%',
        bgcolor: 'background.paper',
        boxShadow: 24,
        p: 1,
        maxHeight: '700px',
        overflow: 'auto',
        borderRadius: '8px'
    };

    const api = useApi();
    const [rows, setRows] = useState([]);

    function formatarData(data) {
        const meses = [
            'Janeiro',
            'Fevereiro',
            'Março',
            'Abril',
            'Maio',
            'Junho',
            'Julho',
            'Agosto',
            'Setembro',
            'Outubro',
            'Novembro',
            'Dezembro'
        ];

        const partes = data.split('-'); // Divide a data em partes [ano, mês]
        const ano = partes[0];
        const mes = parseInt(partes[1], 10) - 1; // Converte o mês para índice (0-11)

        return `${meses[mes]} de ${ano}`;
    }

    const formatCurrency = new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL'
    });

    const getTaxes = async () => {
        try {
            const { data } = await api.getProjTaxes(dataParams.mesMovimento, dataParams.mesMovimento);
            console.log('🚀 ~ getConsumption ~ data:', data);
            const row = data.map((item, index) => ({
                ...item,
                data: formatarData(item.mesMovimento),
                difal: formatarValorIntl(item.difal),
                icms: formatarValorIntl(item.icms),
                pis: formatarValorIntl(item.pis),
                cofins: formatarValorIntl(item.cofins),
                irpj_csll: formatarValorIntl(item.irpj_csll),
                timpostos: formatarValorIntl(item.timpostos)
            }));
            setRows(row);
        } catch (error) {
            console.log('🚀 ~ file: index.js:15 ~ getConsumption ~ error:', error);
        }
    };

    useEffect(() => {
        if (open) {
            getTaxes();
        }
    }, [open]);

    const columns = [
        { field: 'projeto', headerName: 'Projeto', width: 130 },
        { field: 'data', headerName: 'Período', width: 130 },
        { field: 'difal', headerName: 'DIFAL', width: 100 },
        { field: 'icms', headerName: 'ICMS', type: 'number', width: 300 },
        { field: 'pis', headerName: 'PIS', type: 'number', width: 100 },
        { field: 'cofins', headerName: 'COFINS', type: 'number', width: 100 },
        { field: 'irpj_csll', headerName: 'IRPJ/CSLL', type: 'number', width: 100 },
        { field: 'timpostos', headerName: 'Total Impostos', type: 'number', width: 100 }
    ];
    return (
        <>
            <Modal
                open={open}
                onClose={() => setOpen(false)}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style} onClick={(e) => e.stopPropagation()}>
                    <h2 style={{ textAlign: 'center' }}>{`Impostos - ${formatarData(dataParams?.mesMovimento)}`}</h2>
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            width: '100%',
                            margin: 'auto',
                            marginTop: '10px',
                            overflow: 'auto'
                        }}
                    >
                        <TableContainer component={Paper}>
                            <Table sx={{ minWidth: 650 }}>
                                <TableHead>
                                    <TableRow>
                                        {columns.map((column) => (
                                            <TableCell sx={{ fontSize: currentMode.th }} key={column.field} align="center">
                                                {column.headerName}
                                            </TableCell>
                                        ))}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {rows.map((row) => (
                                        <TableRow key={row.id}>
                                            {columns.map((column) => (
                                                <TableCell sx={{ fontSize: currentMode.tb }} key={column.field} align="center">
                                                    {column.renderCell ? column.renderCell({ row }) : row[column.field]}
                                                </TableCell>
                                            ))}
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </div>
                </Box>
            </Modal>
        </>
    );
};

export default TaxesModal;
